export default "__VITE_ASSET__CKMTawAY__"